import React from 'react';
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import './FilterLine.css';
import {Button, ButtonGroup} from 'react-bootstrap';
// import moment from 'moment';
import i18n from 'i18next';

import Accordion from 'react-bootstrap/Accordion';

class FilterLine extends React.Component {
  render() {
    return (
      <div className='row manage-panel-wrap'>
        <ButtonGroup className='text-enter manage-panel'>
          <Accordion.Toggle as={Button} variant="outline-secondary" eventKey="mainCalendar">
            {i18n.t('Show/Hide calendar')}
          </Accordion.Toggle>
        </ButtonGroup>
      </div>
    );
  }
}

export default FilterLine;
